import { PaginationRequest } from '../config/common';

export class PaginationSubcontractorRequest extends PaginationRequest {
    name?: string = '';
    email?: string = '';
}

export interface CreateSubcontractorRequest {
    name?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    town?: string;
    county?: string;
    mobilePhone?: string;
    homePhone?: string;
    email?: string;
    postcode?: string;
    nextKinName?: string;
    nextKinPhone?: string;
    bankName?: string;
    bankAC?: string;
    bankSC?: string;
    niNumber?: string;
    plInsuranceExpiry?: string;
    gitInsuranceExpiry?: string;
    motExpiry?: string;
    vehicleInsuranceExpiry?: string;
    licenceExpiry?: string;
    vatNumber?: string;
    vatCurrency?: string;
    haulageExchangeID?: string;
    paymentTerms?: number;
    subInactive?: boolean;
    supplierCode?: string;
    vehicleTypeID?: string;
    sageId?: string;
    xeroContactID?: string;
    isCompany1?: string;
}

export interface SubcontractorEmailUpdateModel {
    consignmentId: string;
    subcontractorEmail: string;
    subcontractorId: string;
}
